import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Modal } from 'almanac-ui/Modal'
import { useOpenSettings } from 'hooks/useOpenSettings'
import { SettingScreen } from 'components/Settings/types'
import Styles from './BeforeDeleteAccount.module.scss'

interface Props {
  onBack: () => void
  onDeleteAccount: () => void
  onClose: () => void
  isSoleAdminOfMultiMemberWorkspace?: boolean
}

export const BeforeDeleteAccount = ({
  onBack,
  onDeleteAccount,
  onClose,
  isSoleAdminOfMultiMemberWorkspace = false,
}: Props) => {
  const { openSettings } = useOpenSettings()

  const handleTransferOwnership = () => {
    onClose()
    openSettings(SettingScreen.Members)
  }

  return (
    <div className={Styles.container}>
      <Modal.Header title="Delete account" onClose={onClose} />
      <div className={Styles.content}>
        <Heading level={2} color="var(--dark-80)">
          Before you delete your account
        </Heading>

        <Text variant="primary" color="var(--dark-80)">
          You can keep your workspace and data by transferring ownership to another member and
          assigning them as an admin.
        </Text>

        <Text variant="secondary" color="var(--dark-60)">
          Note: You can't delete your account if you're the only admin in a workspace with other
          members. Please assign another admin first.
        </Text>
      </div>
      <div className={Styles.footer}>
        <Button className={Styles.backButton} variant="tertiary" size="lg" onPress={onBack}>
          Back
        </Button>
        <div className={Styles.buttonGroup}>
          <Button
            variant="secondary"
            size="lg"
            onPress={onDeleteAccount}
            isDisabled={isSoleAdminOfMultiMemberWorkspace}
            className={Styles.deleteButton}
          >
            Delete Account & Workspace(s)
          </Button>
          <Button variant="primary" size="lg" onPress={handleTransferOwnership}>
            {isSoleAdminOfMultiMemberWorkspace ? 'Transfer Ownership' : 'Keep Workspace & Transfer'}
          </Button>
        </div>
      </div>
    </div>
  )
}
